export const PARTNER_HOME = "/partner/dashboard";
export const PARTNER_START = "/partner/start";
export const ADMIN_HOME = "/admin/dashboard";

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("userDetail"));
  } catch {
    return null;
  }
};

/**
 * A referral partner holds no permission keys, so every admin screen would either refuse them or
 * render empty. A platform admin keeps the admin app even when one of their memberships is a
 * referral one.
 */
export const isReferralPortalUser = (userDetail) => {
  if (!userDetail || userDetail.platformAdmin) return false;
  const role = userDetail.orgRole ?? userDetail.type;
  return role === "REFERRAL_USER";
};

export const currentUserBelongsInPartnerPortal = () => isReferralPortalUser(readStoredUser());

/**
 * Anyone in the office may refer clients, so the portal is offered to every staff member rather
 * than gated on a permission key. Referring is not an admin capability: what a staff partner sees
 * there is their own referrals and nothing else, exactly as an outside partner does. It needs an
 * active organization, because the partner profile the portal runs on belongs to one.
 */
export const canManageOwnReferrals = (userDetail) => {
  if (!userDetail || isReferralPortalUser(userDetail)) return false;
  return Boolean(userDetail.activeOrgId ?? userDetail.organization?.id);
};

export const currentUserCanManageOwnReferrals = () => canManageOwnReferrals(readStoredUser());

/** Staff keep a way back to the admin app; an outside partner has nowhere else to be. */
export const isStaffInPartnerPortal = (userDetail) =>
  Boolean(userDetail) && !isReferralPortalUser(userDetail);

export const currentUserIsStaffInPartnerPortal = () => isStaffInPartnerPortal(readStoredUser());

export const homeRouteFor = (userDetail) =>
  isReferralPortalUser(userDetail) ? PARTNER_HOME : ADMIN_HOME;

export const currentUserHomeRoute = () => homeRouteFor(readStoredUser());
